import $ from 'jquery';

// Removed unused function displayDates()

// Global variables
let userGlobal = {};
let currentTeamId = '';
let teams = [];
let billingAccounts = [];
let teamMembers = {};
let accountHydrated = false;

function setMdlTextfieldValue(selector, value) {
  const input = document.querySelector(selector);
  if (!input) {
    return;
  }

  input.value = value || '';
  const container = input.closest('.mdl-textfield');
  if (!container) {
    return;
  }

  if (input.value) {
    container.classList.add('is-dirty');
  } else {
    container.classList.remove('is-dirty');
  }

  if (container.MaterialTextfield && typeof container.MaterialTextfield.checkDirty === 'function') {
    container.MaterialTextfield.checkDirty();
  }
}

function hydrateAccount(userData) {
  if (!userData || accountHydrated) {
    return;
  }

  const email = userData.email || '';
  const name = userData.name || (email ? email.split('@')[0] : '');

  // Update visible fields
  $('.email').text(email);
  $('.name').text(name);

  // Persist for later requests
  userGlobal = {
    email,
    displayName: name,
    uid: userData.id,
    secret: userData.secret
  };

  // Derive a lightweight personal team so the UI never stays in "loading" state
  const personalTeamId =
    userData.personal_team_id || userData.active_team_id || userData.id || 'personal-team';
  currentTeamId = personalTeamId;
  const personalTeam = {
    id: personalTeamId,
    team_type: 'personal',
    name: 'Personal',
    description: 'Your personal workspace',
    billing_account_id: null,
    stripe_subscription_id: null
  };

  teams = [personalTeam];
  populateTeamSelector(teams);
  populateTeamsList(teams);
  showTeamDetails(personalTeamId);

  // Replace billing placeholder with an empty state
  billingAccounts = [];
  populateBillingAccountsList(billingAccounts);

  // Show team selector in header when available
  $('.header-team-selector').show();

  accountHydrated = true;
}

// Initialize the application
initApp = function () {
  // Use SimpleAuth instead of Firebase
  $(document).on('user-ready', function (event, userData) {
    const data = userData || (event && event.detail) || window.userData;
    if (data && data.secret) {
      hydrateAccount(data);
      // User is signed in with SimpleAuth
      var displayName = data.name;
      var email = data.email;
      // var emailVerified = true; // SimpleAuth users are verified through login - removed unused
      // var photoURL = null; // Not available in SimpleAuth - removed unused
      var uid = data.id;
      // var phoneNumber = null; // Not available in SimpleAuth - removed unused
      // var providerData = null; // Not needed in SimpleAuth - removed unused

      // Create user object compatible with existing code
      const user = {
        email: email,
        displayName: displayName,
        uid: uid,
        secret: data.secret
      };

      userGlobal = user;

      // Ensure we get email in the user object
      if (!email) {
        console.warn('No email found in user data');
      }

      // Ensure we get name in the user object
      if (!displayName && email) {
        displayName = email.split('@')[0]; // Extract name from email if not provided
      }

      // Update user object
      user.email = email;
      user.displayName = displayName;

      getUser(user, function (data) {
        // Prefer response data but fall back to already-set userGlobal
        const merged = {
          ...user,
          ...data
        };

        userGlobal.secret = merged.secret;
        const mergedEmail = merged.email || '';
        const mergedName = merged.name || merged.displayName || mergedEmail.split('@')[0] || '';

        $('.email').text(mergedEmail);
        $('.name').text(mergedName);

        setMdlTextfieldValue('#ainame', mergedName);

        const photoUrl = merged.avatar_photo_url;
        if (photoUrl && $('#newaiavatarurl').length) {
          $('#newaiavatarurl').val(photoUrl);
        }

        if (photoUrl && $('#new-ai-avatar-image').length) {
          $('#new-ai-avatar-image').html(
            `<img src="https://appstatic.app.nz/${photoUrl}" width="81" height="81"/>`
          );
        }

        if (merged.stripe_id && $('#manage-subscriptions-link').length) {
          $('#manage-subscriptions-link').html(
            `<a href="/portal?customer_id=${merged.stripe_id}" target="_blank" class="mdl-button mdl-js-button">Manage Subscriptions</a>`
          );
        }

        // Set current team and re-render base UI immediately
        currentTeamId =
          merged.active_team_id || merged.personal_team_id || merged.uid || merged.id || currentTeamId;
        hydrateAccount(merged);
      });
    } else {
      if (window.location.pathname.startsWith('/account')) {
        location.href = '/login';
      }
    }
  });

  // If userData is already present (e.g., injected before load), hydrate immediately
  if (window.userData && window.userData.secret) {
    hydrateAccount(window.userData);
  }

  // Dialog event handlers
  $('#add-user-btn').on('click', function (e) {
    e.preventDefault();
    var dialog = document.getElementById('edit-user-dialog');
    dialog.showModal();
  });

  $('#create-team-btn').on('click', function (e) {
    e.preventDefault();
    var dialog = document.getElementById('create-team-dialog');
    populateBillingAccountSelect('#billing-account-select');
    dialog.showModal();
  });

  $('#create-billing-account-btn').on('click', function (e) {
    e.preventDefault();
    var dialog = document.getElementById('create-billing-account-dialog');
    dialog.showModal();
  });

  $('#invite-member-btn').on('click', function (e) {
    e.preventDefault();
    $('#invite-team-id').val(currentTeamId);
    var dialog = document.getElementById('invite-member-dialog');
    dialog.showModal();
  });

  $('#manage-team-billing-btn').on('click', function (e) {
    e.preventDefault();
    $('#billing-team-id').val(currentTeamId);
    populateBillingAccountSelect('#manage-billing-account-select');
    var dialog = document.getElementById('manage-team-billing-dialog');
    dialog.showModal();
  });

  // Delete team button
  $('#delete-team-btn').on('click', function (e) {
    e.preventDefault();
    const team = teams.find(t => t.id === currentTeamId);
    if (team) {
      $('#delete-team-id').val(team.id);
      $('#delete-team-name').text(team.name);
      $('#actual-team-name').val(team.name);
      $('#confirm-team-name').val('');
      $('#confirm-delete-team-btn').prop('disabled', true);
      var dialog = document.getElementById('confirm-delete-team-dialog');
      dialog.showModal();
    }
  });

  // Leave team button
  $('#leave-team-btn').on('click', function (e) {
    e.preventDefault();
    const team = teams.find(t => t.id === currentTeamId);
    if (team) {
      $('#leave-team-id').val(team.id);
      $('#leave-team-name').text(team.name);
      var dialog = document.getElementById('confirm-leave-team-dialog');
      dialog.showModal();
    }
  });

  // Close dialog buttons
  $('.mdl-dialog .close').click(function (event) {
    // get parent dialog element by name
    var dialog = $(this).parents('dialog').get(0);
    dialog.close();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  // Team selector change handler
  $('#team-selector').on('change', function () {
    const selectedTeamId = $(this).val();
    if (selectedTeamId === '__create__') {
      $(this).val(currentTeamId || 'personal');
      const $dlg = $('#create-team-dialog');
      const dlg = $dlg[0];
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
      } else {
        $('#create-team-btn').trigger('click');
      }
      return;
    }
    setActiveTeam(selectedTeamId);
  });
};

// Load teams for the current user - COMMENTED OUT FOR NOW
function loadTeams() {
  // COMMENTED OUT - causing 404 errors
  /*
  fetch('/api/teams', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userGlobal.secret}`
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      teams = data.teams;

      // Populate team selector dropdown
      populateTeamSelector(teams);

      // Populate teams list
      populateTeamsList(teams);

      // If we have a current team ID, show its details
      if (currentTeamId) {
        showTeamDetails(currentTeamId);
      }
    } else {
      console.error('Error loading teams:', data.error);
    }
  })
  .catch(error => {
    console.error('Error loading teams:', error);
  });
  */

  // Temporarily disabled - just log that this was called
  console.log('loadTeams() called but disabled for now');
}

// Load billing accounts for the current user - COMMENTED OUT FOR NOW
function loadBillingAccounts() {
  // COMMENTED OUT - causing 404 errors
  /*
  fetch('/api/billing-accounts', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userGlobal.secret}`
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      billingAccounts = data.billingAccounts;
      populateBillingAccountsList(billingAccounts);
    } else {
      console.error('Error loading billing accounts:', data.error);
    }
  })
  .catch(error => {
    console.error('Error loading billing accounts:', error);
  });
  */

  // Temporarily disabled - just log that this was called
  console.log('loadBillingAccounts() called but disabled for now');
}

// Load team members for a specific team
function loadTeamMembers(teamId) {
  fetch(`/api/teams/${teamId}/members`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        teamMembers[teamId] = data.members;
        populateTeamMembersList(teamId, data.members);
      } else {
        console.error('Error loading team members:', data.error);
      }
    })
    .catch(error => {
      console.error('Error loading team members:', error);
    });
}

// Populate team selector dropdown
function populateTeamSelector(teams) {
  const $selector = $('#team-selector');
  $selector.empty();

  const personalTeam = teams.find(team => team.team_type === 'personal');
  const otherTeams = teams.filter(team => team.team_type !== 'personal');

  if (personalTeam) {
    $selector.append(
      `<option value="${personalTeam.id}" ${currentTeamId === personalTeam.id ? 'selected' : ''}>Personal</option>`
    );
  }

  otherTeams.forEach(team => {
    $selector.append(
      `<option value="${team.id}" ${currentTeamId === team.id ? 'selected' : ''}>${team.name}</option>`
    );
  });

  // If the user has no real teams yet, surface a "+ New team" action in the
  // selector so the dropdown does something useful instead of just listing Personal.
  if (otherTeams.length === 0) {
    $selector.append('<option value="__create__">+ New team</option>');
  }
}

// Populate teams list on account page
function populateTeamsList(teams) {
  const $list = $('#teams-list');
  $list.empty();

  teams.forEach(team => {
    let isActive = team.id === currentTeamId;
    $list.append(`
      <li class="mdl-list__item mdl-list__item--two-line team-list-item ${isActive ? 'active' : ''}" data-team-id="${team.id}">
        <span class="mdl-list__item-primary-content">
          ${
  team.avatar_photo_url
    ? `<img src="https://appstatic.app.nz/${team.avatar_photo_url}" class="mdl-list__item-avatar">`
    : `<i class="material-icons mdl-list__item-avatar">${team.team_type === 'personal' ? 'person' : 'group'}</i>`
}
          <span>${team.name}</span>
          <span class="mdl-list__item-sub-title">${team.team_type === 'personal' ? 'Personal Team' : team.description || 'Team'}</span>
        </span>
        <span class="mdl-list__item-secondary-content">
          <button class="mdl-button mdl-js-button mdl-button--icon select-team-btn" data-team-id="${team.id}">
            <i class="material-icons">arrow_forward</i>
          </button>
        </span>
      </li>
    `);
  });

  // Add click handlers to show team details
  $list.find('.team-list-item').on('click', function () {
    const teamId = $(this).data('team-id');
    showTeamDetails(teamId);
  });

  // Add click handlers for the select team button
  $list.find('.select-team-btn').on('click', function (e) {
    e.stopPropagation();
    const teamId = $(this).data('team-id');
    setActiveTeam(teamId);
  });
}

// Populate billing accounts list
function populateBillingAccountsList(accounts) {
  const $list = $('#billing-accounts-list');
  $list.empty();

  if (accounts.length === 0) {
    $list.append(`
      <li class="mdl-list__item mdl-list__item--two-line">
        <span class="mdl-list__item-primary-content">
          <i class="material-icons mdl-list__item-avatar">account_balance_wallet</i>
          <span>No billing accounts</span>
          <span class="mdl-list__item-sub-title">Create a billing account to manage subscriptions</span>
        </span>
      </li>
    `);
    return;
  }

  accounts.forEach(account => {
    $list.append(`
      <li class="mdl-list__item mdl-list__item--two-line">
        <span class="mdl-list__item-primary-content">
          <i class="material-icons mdl-list__item-avatar">account_balance_wallet</i>
          <span>${account.name}</span>
          <span class="mdl-list__item-sub-title">${account.contact_name} (${account.contact_email})</span>
        </span>
        <span class="mdl-list__item-secondary-content">
          <button class="mdl-button mdl-js-button mdl-button--icon manage-billing-btn" data-account-id="${account.id}">
            <i class="material-icons">settings</i>
          </button>
        </span>
      </li>
    `);
  });

  // Add click handlers for managing billing accounts
  $list.find('.manage-billing-btn').on('click', function () {
    const accountId = $(this).data('account-id');
    console.log('Manage billing account:', accountId);
    // TODO: Implement billing account management
  });
}

// Populate billing account select dropdown
function populateBillingAccountSelect(selectId) {
  const $select = $(selectId);
  $select.find('option:not(:first)').remove();

  billingAccounts.forEach(account => {
    $select.append(`<option value="${account.id}">${account.name}</option>`);
  });
}

// Populate team members list
function populateTeamMembersList(teamId, members) {
  const $list = $('#team-members-list');
  $list.empty();

  if (members.length === 0) {
    $list.append(`
      <li class="mdl-list__item">
        <span class="mdl-list__item-primary-content">
          <i class="material-icons mdl-list__item-avatar">person_off</i>
          <span>No team members</span>
        </span>
      </li>
    `);
    return;
  }

  members.forEach(member => {
    const statusBadge = getStatusBadge(member.status);
    const roleBadge = getRoleBadge(member.role);

    $list.append(`
      <li class="mdl-list__item mdl-list__item--two-line">
        <span class="mdl-list__item-primary-content">
          <i class="material-icons mdl-list__item-avatar">person</i>
          <span>
            ${member.name || member.invitation_email}
            ${statusBadge}
            ${roleBadge}
          </span>
          <span class="mdl-list__item-sub-title">${member.email || member.invitation_email}</span>
        </span>
        <span class="mdl-list__item-secondary-content">
          ${
  member.status === 'invited'
    ? `
            <button class="mdl-button mdl-js-button mdl-button--icon resend-invite-btn" data-member-id="${member.id}">
              <i class="material-icons">refresh</i>
            </button>
          `
    : ''
}
          ${
  member.role !== 'owner'
    ? `
            <button class="mdl-button mdl-js-button mdl-button--icon remove-member-btn" data-member-id="${member.id}">
              <i class="material-icons">remove_circle_outline</i>
            </button>
          `
    : ''
}
        </span>
      </li>
    `);
  });

  // Add click handlers for resending invites
  $list.find('.resend-invite-btn').on('click', function () {
    const memberId = $(this).data('member-id');
    resendInvite(teamId, memberId);
  });

  // Add click handlers for removing members
  $list.find('.remove-member-btn').on('click', function () {
    const memberId = $(this).data('member-id');
    if (confirm('Are you sure you want to remove this member from the team?')) {
      removeMember(teamId, memberId);
    }
  });
}

// Get status badge HTML
function getStatusBadge(status) {
  if (status === 'invited') {
    return '<span class="invitation-badge invitation-pending">Pending</span>';
  } else if (status === 'active') {
    return '<span class="invitation-badge invitation-accepted">Active</span>';
  } else if (status === 'declined') {
    return '<span class="invitation-badge invitation-declined">Declined</span>';
  }
  return '';
}

// Get role badge HTML
function getRoleBadge(role) {
  if (role === 'owner') {
    return '<span class="member-role role-owner">Owner</span>';
  } else if (role === 'admin') {
    return '<span class="member-role role-admin">Admin</span>';
  } else if (role === 'member') {
    return '<span class="member-role role-member">Member</span>';
  }
  return '';
}

// Show team details
function showTeamDetails(teamId) {
  const team = teams.find(t => t.id === teamId);
  if (!team) return;

  // Update active team in the list
  $('.team-list-item').removeClass('active');
  $(`.team-list-item[data-team-id="${teamId}"]`).addClass('active');

  // Update team detail container
  $('#team-detail-name').text(team.name);
  $('#team-detail-container').show();

  // Load team members if we don't have them yet (skip for personal teams - they only have owner)
  if (team.team_type === 'personal') {
    teamMembers[teamId] = [];
    populateTeamMembersList(teamId, []);
  } else if (!teamMembers[teamId]) {
    loadTeamMembers(teamId);
  } else {
    populateTeamMembersList(teamId, teamMembers[teamId]);
  }

  // Update the billing info
  $('#team-plan-name').text(team.stripe_subscription_id ? 'Team' : 'Free');

  // Get seat count from the member list or from the subscription
  const memberCount = teamMembers[teamId] ? teamMembers[teamId].length : 1;
  $('#team-seat-count').text(memberCount);

  // Show billing account if available
  if (team.billing_account_id) {
    const billingAccount = billingAccounts.find(acc => acc.id === team.billing_account_id);
    if (billingAccount) {
      $('#team-billing-account').html(`Billing Account: <span>${billingAccount.name}</span>`);
    } else {
      $('#team-billing-account').html('Billing Account: <span>Unknown</span>');
    }
  } else {
    $('#team-billing-account').html('Billing Account: <span>None</span>');
  }

  // Show/hide manage billing button based on team type
  if (team.team_type === 'personal') {
    $('#manage-team-billing-btn').hide();
  } else {
    $('#manage-team-billing-btn').show();
  }

  // Show/hide team actions based on role and team type
  if (team.team_type === 'personal') {
    // Hide both action sections for personal teams
    $('#team-owner-actions').hide();
    $('#team-member-actions').hide();
  } else if (team.role === 'owner') {
    // Show owner actions, hide member actions
    $('#team-owner-actions').show();
    $('#team-member-actions').hide();
  } else {
    // Show member actions, hide owner actions
    $('#team-owner-actions').hide();
    $('#team-member-actions').show();
  }
}

// Set the active team for the user - COMMENTED OUT FOR NOW
function setActiveTeam(teamId) {
  // COMMENTED OUT - causing 404 errors
  /*
  fetch('/api/user/active-team', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userGlobal.secret}`
    },
    body: JSON.stringify({
      teamId: teamId
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Update current team ID
      currentTeamId = teamId;

      // Update UI
      const team = teams.find(t => t.id === teamId);
      if (team) {
        $('#current-team-name').text(team.name);

        // Update team selector in sidebar
        $('#team-selector').val(teamId);

        // Update teams list
        $('.team-list-item').removeClass('active');
        $(`.team-list-item[data-team-id="${teamId}"]`).addClass('active');

        // Show team details
        showTeamDetails(teamId);
      }
    } else {
      console.error('Error setting active team:', data.error);
    }
  })
  .catch(error => {
    console.error('Error setting active team:', error);
  });
  */

  // Temporarily disabled - just log the team change
  console.log('setActiveTeam() called but disabled for now, teamId:', teamId);
  currentTeamId = teamId;
}

// Resend invitation to a team member
function resendInvite(teamId, memberId) {
  fetch(`/api/teams/${teamId}/members/${memberId}/resend-invite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        alert('Invitation resent successfully');
      } else {
        console.error('Error resending invitation:', data.error);
        alert(`Error resending invitation: ${data.error}`);
      }
    })
    .catch(error => {
      console.error('Error resending invitation:', error);
      alert('Error resending invitation. Please try again.');
    });
}

// Remove a member from the team
function removeMember(teamId, memberId) {
  fetch(`/api/teams/${teamId}/members/${memberId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Update team members list
        if (teamMembers[teamId]) {
          teamMembers[teamId] = teamMembers[teamId].filter(m => m.id !== memberId);
          populateTeamMembersList(teamId, teamMembers[teamId]);
        }

        // Update seat count
        const memberCount = teamMembers[teamId] ? teamMembers[teamId].length : 0;
        $('#team-seat-count').text(memberCount);
      } else {
        console.error('Error removing member:', data.error);
        alert(`Error removing member: ${data.error}`);
      }
    })
    .catch(error => {
      console.error('Error removing member:', error);
      alert('Error removing member. Please try again.');
    });
}

// Form submission handlers
function submitUserDataForm(e) {
  // get all form data from the current form
  let ainame = document.getElementById('ainame').value;
  let newaiavatarurl = document.getElementById('newaiavatarurl').value;

  $('#signupDialogError').hide();
  fetch('/attach-userdata', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      uid: userGlobal.uid,
      secret: userGlobal.secret,
      ainame: ainame,
      newaiavatarurl: newaiavatarurl
    })
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      console.log(data);
      if (typeof data.error === 'undefined' || data.success) {
        document.getElementById('edit-user-dialog').close();
        $('.name').html(ainame);
      } else {
        $('#signupDialogError').html(data.error || 'Sorry there was an Error - try again');
        $('#signupDialogError').show();
        $('#signupDialogError').css('visibility', 'visible');
      }
    })
    .catch(function (error) {
      console.log(error);
      $('#signupDialogError').html('Sorry there was an Error - try again');
      $('#signupDialogError').show();
      $('#signupDialogError').css('visibility', 'visible');
    });
}

// Create Team Form Handler
function submitCreateTeamForm(e) {
  e.preventDefault();

  const teamName = $('#team-name').val();
  const teamDescription = $('#team-description').val();
  const teamAvatarUrl = $('#team-avatar-url').val();
  const billingAccountId = $('#billing-account-select').val();

  fetch('/api/teams', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    },
    body: JSON.stringify({
      name: teamName,
      description: teamDescription,
      avatar_photo_url: teamAvatarUrl,
      billing_account_id: billingAccountId
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('create-team-dialog').close();

        // Add the new team to our list
        teams.push(data.team);

        // Reload teams to update the UI
        populateTeamSelector(teams);
        populateTeamsList(teams);

        // Show the new team's details
        showTeamDetails(data.team.id);
      } else {
        $('#createTeamError').html(data.error || 'Sorry there was an Error - try again');
        $('#createTeamError').show();
        $('#createTeamError').css('visibility', 'visible');
      }
    })
    .catch(error => {
      console.error('Error creating team:', error);
      $('#createTeamError').html('Sorry there was an Error - try again');
      $('#createTeamError').show();
      $('#createTeamError').css('visibility', 'visible');
    });
}

// Create Billing Account Form Handler
function submitCreateBillingAccountForm(e) {
  e.preventDefault();

  const billingName = $('#billing-name').val();
  const contactName = $('#contact-name').val();
  const contactEmail = $('#contact-email').val();
  const addressLine1 = $('#address-line1').val();
  const addressLine2 = $('#address-line2').val();
  const city = $('#city').val();
  const state = $('#state').val();
  const postalCode = $('#postal-code').val();
  const country = $('#country').val();
  const taxIdType = $('#tax-id-type').val();
  const taxIdValue = $('#tax-id-value').val();

  fetch('/api/billing-accounts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    },
    body: JSON.stringify({
      name: billingName,
      contact_name: contactName,
      contact_email: contactEmail,
      address_line1: addressLine1,
      address_line2: addressLine2,
      city: city,
      state: state,
      postal_code: postalCode,
      country: country,
      tax_id_type: taxIdType,
      tax_id_value: taxIdValue
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('create-billing-account-dialog').close();

        // Add the new billing account to our list
        billingAccounts.push(data.billingAccount);

        // Reload billing accounts to update the UI
        populateBillingAccountsList(billingAccounts);
      } else {
        $('#createBillingAccountError').html(data.error || 'Sorry there was an Error - try again');
        $('#createBillingAccountError').show();
        $('#createBillingAccountError').css('visibility', 'visible');
      }
    })
    .catch(error => {
      console.error('Error creating billing account:', error);
      $('#createBillingAccountError').html('Sorry there was an Error - try again');
      $('#createBillingAccountError').show();
      $('#createBillingAccountError').css('visibility', 'visible');
    });
}

// Invite Team Member Form Handler
function submitInviteMemberForm(e) {
  e.preventDefault();

  const teamId = $('#invite-team-id').val();
  const email = $('#invite-email').val();
  const role = $('#invite-role').val();

  fetch(`/api/teams/${teamId}/invite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    },
    body: JSON.stringify({
      email: email,
      role: role
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('invite-member-dialog').close();

        // Reload team members to update the UI
        loadTeamMembers(teamId);
      } else {
        $('#inviteMemberError').html(data.error || 'Sorry there was an Error - try again');
        $('#inviteMemberError').show();
        $('#inviteMemberError').css('visibility', 'visible');
      }
    })
    .catch(error => {
      console.error('Error inviting team member:', error);
      $('#inviteMemberError').html('Sorry there was an Error - try again');
      $('#inviteMemberError').show();
      $('#inviteMemberError').css('visibility', 'visible');
    });
}

// Manage Team Billing Form Handler
function submitManageTeamBillingForm(e) {
  e.preventDefault();

  const teamId = $('#billing-team-id').val();
  const billingAccountId = $('#manage-billing-account-select').val();
  const selectedPlan = $('input[name="selected-plan"]:checked').val();

  fetch(`/api/teams/${teamId}/billing`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    },
    body: JSON.stringify({
      billing_account_id: billingAccountId,
      plan: selectedPlan
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('manage-team-billing-dialog').close();

        // Update team data
        const teamIndex = teams.findIndex(t => t.id === teamId);
        if (teamIndex !== -1) {
          teams[teamIndex].billing_account_id = billingAccountId;
          teams[teamIndex].stripe_subscription_id = data.subscription_id;
        }

        // Show updated team details
        showTeamDetails(teamId);
      } else {
        $('#manageTeamBillingError').html(data.error || 'Sorry there was an Error - try again');
        $('#manageTeamBillingError').show();
        $('#manageTeamBillingError').css('visibility', 'visible');
      }
    })
    .catch(error => {
      console.error('Error updating team billing:', error);
      $('#manageTeamBillingError').html('Sorry there was an Error - try again');
      $('#manageTeamBillingError').show();
      $('#manageTeamBillingError').css('visibility', 'visible');
    });
}

window.addEventListener('load', function () {
  initApp();
});

// Delete a team
function deleteTeam(teamId) {
  fetch(`/api/teams/${teamId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('confirm-delete-team-dialog').close();

        // Remove team from list
        teams = teams.filter(t => t.id !== teamId);

        // Update UI
        populateTeamSelector(teams);
        populateTeamsList(teams);

        // If the deleted team was the active team, switch to personal team
        if (currentTeamId === teamId) {
          const personalTeam = teams.find(t => t.team_type === 'personal');
          if (personalTeam) {
            setActiveTeam(personalTeam.id);
          }
        } else {
          // Hide team details
          $('#team-detail-container').hide();
        }
      } else {
        alert(`Error deleting team: ${data.error}`);
      }
    })
    .catch(error => {
      console.error('Error deleting team:', error);
      alert('Error deleting team. Please try again.');
    });
}

// Leave a team
function leaveTeam(teamId) {
  // We'll implement this as removing self from the team
  // Get our member ID first
  const teamMembersList = teamMembers[teamId] || [];
  const myMembership = teamMembersList.find(m => m.user_id === userGlobal.uid);

  if (!myMembership) {
    alert('Error: Could not find your membership in this team.');
    return;
  }

  fetch(`/api/teams/${teamId}/members/${myMembership.id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userGlobal.secret}`
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        document.getElementById('confirm-leave-team-dialog').close();

        // Remove team from our list
        teams = teams.filter(t => t.id !== teamId);

        // Update UI
        populateTeamSelector(teams);
        populateTeamsList(teams);

        // If the left team was the active team, switch to personal team
        if (currentTeamId === teamId) {
          const personalTeam = teams.find(t => t.team_type === 'personal');
          if (personalTeam) {
            setActiveTeam(personalTeam.id);
          }
        } else {
          // Hide team details
          $('#team-detail-container').hide();
        }
      } else {
        alert(`Error leaving team: ${data.error}`);
      }
    })
    .catch(error => {
      console.error('Error leaving team:', error);
      alert('Error leaving team. Please try again.');
    });
}

$(document).ready(function () {
  // User data form
  $('#submitUserDataForm').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitUserDataForm(e);
    return false;
  });

  // Create team form
  $('#createTeamForm').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitCreateTeamForm(e);
    return false;
  });

  // Create billing account form
  $('#createBillingAccountForm').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitCreateBillingAccountForm(e);
    return false;
  });

  // Invite member form
  $('#inviteMemberForm').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitInviteMemberForm(e);
    return false;
  });

  // Manage team billing form
  $('#manageTeamBillingForm').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitManageTeamBillingForm(e);
    return false;
  });

  // Confirm delete team button
  $('#confirm-delete-team-btn').on('click', function (e) {
    e.preventDefault();
    const teamId = $('#delete-team-id').val();
    deleteTeam(teamId);
  });

  // Confirm leave team button
  $('#confirm-leave-team-btn').on('click', function (e) {
    e.preventDefault();
    const teamId = $('#leave-team-id').val();
    leaveTeam(teamId);
  });

  // Validate team name confirmation for deletion
  $('#confirm-team-name').on('input', function () {
    const actualName = $('#actual-team-name').val();
    const typedName = $(this).val();

    // Enable delete button only if names match exactly
    $('#confirm-delete-team-btn').prop('disabled', actualName !== typedName);
  });

  // File upload handlers for account/team avatars. The app also has a dataset
  // upload input with this id, so bind only when the account preview exists.
  const newAvatarInput = document.getElementById('new-ai-avatar');
  if (
    newAvatarInput &&
    document.querySelector('#new-ai-avatar-image') &&
    !newAvatarInput.closest('#datasets-file-upload-button')
  ) {
    newAvatarInput.addEventListener('change', function () {
      handleFileUpload(this, '#new-ai-avatar-image', '#newaiavatarurl');
    });
  }

  if (document.getElementById('team-avatar')) {
    document.getElementById('team-avatar').addEventListener('change', function () {
      handleFileUpload(this, '#team-avatar-preview', '#team-avatar-url');
    });
  }
});

// Handle file upload for avatars
function handleFileUpload(input, previewSelector, urlInputSelector) {
  if (input.files && input.files[0]) {
    const file = input.files[0];
    const $preview = $(previewSelector);
    if (!$preview.length) {
      console.warn('Skipping avatar upload preview; target not found:', previewSelector);
      return;
    }

    // Create FormData
    const formData = new FormData();
    formData.append('file', file);

    // Show loading indicator
    $preview.html('<div class="mdl-spinner mdl-js-spinner is-active"></div>');
    const spinner = $preview.find('.mdl-spinner')[0];
    if (spinner && window.componentHandler && typeof window.componentHandler.upgradeElement === 'function') {
      try {
        window.componentHandler.upgradeElement(spinner);
      } catch (error) {
        console.warn('Could not upgrade avatar upload spinner:', error);
      }
    }

    // Upload file
    fetch('/upload-avatar', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${userGlobal.secret}`
      },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.success && data.url) {
          // Update preview
          $(previewSelector).html(
            `<img src="https://appstatic.app.nz/${data.url}" width="81" height="81"/>`
          );

          // Update hidden input
          $(urlInputSelector).val(data.url);
        } else {
          console.error('Error uploading avatar:', data.error);
          $(previewSelector).html(
            '<span class="material-icons" style="font-size: 71px">error</span>'
          );
        }
      })
      .catch(error => {
        console.error('Error uploading avatar:', error);
        $(previewSelector).html(
          '<span class="material-icons" style="font-size: 71px">error</span>'
        );
      });
  }
}
